import { Header } from "@src/components"

export default function Section() {
  return (
    <>
      <Header title="sections" />
      {/*  */}
    </>
  )
}
